import { useEffect, useRef, useState } from "react";
import { Input } from "@/ui/input";

/**
 * Um texto que vira campo ao ser tocado.
 *
 * O mesmo contrato da ficha: clique abre, Enter grava, Esc desiste, sair do
 * campo grava. Nome vazio não grava — registro sem nome não existe, e quem
 * apagou tudo e clicou fora recebe o nome de volta em vez de um caso anônimo.
 *
 * Arquivo próprio desde 27/08: ele morava dentro de `CabecalhoDoPainel.jsx` e
 * agora é o cabeçalho da CONVERSA que edita o nome e o telefone do cliente —
 * onde o nome está escrito grande e onde a pessoa já está olhando. Peça usada em
 * duas telas sobe para a camada da casa; copiada em duas, envelhece em uma.
 */
export default function TextoEditavel({ valor, exibido, rotulo, convite, classe = "", aoGravar }) {
  const [editando, setEditando] = useState(false);
  const [rascunho, setRascunho] = useState(valor);
  const campo = useRef(null);

  useEffect(() => {
    if (editando) campo.current?.focus();
  }, [editando]);

  const gravar = (bruto) => {
    const novo = String(bruto ?? "").trim();
    setEditando(false);
    if (novo !== String(valor ?? "").trim()) aoGravar(novo);
  };

  if (editando)
    return (
      <Input
        ref={campo}
        value={rascunho}
        placeholder={convite}
        aria-label={rotulo}
        onChange={(e) => setRascunho(e.target.value)}
        onBlur={(e) => gravar(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            setEditando(false);
          }
          if (e.key === "Enter") {
            e.preventDefault();
            gravar(e.currentTarget.value);
          }
        }}
        className={`campo -ml-1.5 h-auto w-full rounded-controle border-terra/35 bg-background px-1.5 py-[2px] text-foreground ${classe}`}
      />
    );

  return (
    <button
      type="button"
      onClick={() => {
        setRascunho(valor);
        setEditando(true);
      }}
      /* A dica traz o VALOR: nome longo trunca na coluna de 300px, e a dica é o
         único lugar onde ele aparece inteiro sem abrir o campo. */
      data-dica={valor ? `${valor} — clique para editar` : `${rotulo} — clique para preencher`}
      /* `-ml` alinha o texto com o resto da coluna: o respiro existe para o
         retângulo do `hover`, não para deslocar a identidade. */
      className={`alvo -ml-1.5 cursor-text rounded-controle border border-transparent bg-transparent px-1.5 py-[2px] text-left transition-colors hover:border-foreground/12 hover:bg-card ${classe} ${
        valor ? "" : "text-tinta-fantasma italic"
      }`}
    >
      {exibido ?? valor ?? ""}
    </button>
  );
}
